import { c as _c } from "react/compiler-runtime";
import styles from './ItineraryTimeline.module.css';
import { ItineraryTimelineGroup } from './ItineraryTimelineGroup';
import type { ItineraryTimelineProps } from './TripItinerary.types';
export function ItineraryTimeline(t0) {
  const $ = _c(18);
  const {
    groups,
    originLocationName,
    isEditable,
    tripId,
    returnLegId,
    cardSection: t1,
    accommodationStaysByItemId
  } = t0;
  const cardSection = t1 === undefined ? "overview" : t1;
  let t2;
  if ($[0] !== accommodationStaysByItemId || $[1] !== cardSection || $[2] !== groups || $[3] !== isEditable || $[4] !== originLocationName || $[5] !== returnLegId || $[6] !== tripId) {
    let t3;
    if ($[8] !== accommodationStaysByItemId || $[9] !== cardSection || $[10] !== groups.length || $[11] !== isEditable || $[12] !== originLocationName || $[13] !== returnLegId || $[14] !== tripId) {
      t3 = (group, index) => <ItineraryTimelineGroup key={group.id} group={group} isLastGroup={index === groups.length - 1} originLocationName={index === 0 ? originLocationName : null} isEditable={isEditable} tripId={tripId} returnLegId={returnLegId} cardSection={cardSection} accommodationStaysByItemId={accommodationStaysByItemId} />;
      $[8] = accommodationStaysByItemId;
      $[9] = cardSection;
      $[10] = groups.length;
      $[11] = isEditable;
      $[12] = originLocationName;
      $[13] = returnLegId;
      $[14] = tripId;
      $[15] = t3;
    } else {
      t3 = $[15];
    }
    t2 = groups.map(t3);
    $[0] = accommodationStaysByItemId;
    $[1] = cardSection;
    $[2] = groups;
    $[3] = isEditable;
    $[4] = originLocationName;
    $[5] = returnLegId;
    $[6] = tripId;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[16] !== t2) {
    t3 = <div className={styles.timelineWrapper}>{t2}</div>;
    $[16] = t2;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  return t3;
}